"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _theme = require("../../../theme");
var useStyles = (0, _theme.makeStyles)(function () {
  return {
    otpInputs: {
      height: '90px',
      width: '70px',
      borderRadius: '5px',
      border: '1px rgba(255, 255, 255, 0.25) solid',
      textAlign: 'center',
      fontWeight: 400,
      fontSize: '24px',
      lineHeight: '38px',
      color: '#FFFFFF',
      backgroundColor: '#000000',
      '&:focus': {
        outline: '1px #00B8A3 solid'
      }
    },
    optContainer: {
      display: 'flex',
      alignItems: 'center',
      width: '100%'
    },
    optInput: {
      display: 'flex',
      justifyContent: 'space-between',
      flex: 1
    }
  };
}, {
  name: 'OTP'
});
exports.useStyles = useStyles;